const getMaterialRequirements = ({ id, page, ...rest }) => ({
  method: "GET",
  url: `/offers/${id}/materials`,
  data: { ...rest, page: page + 1 },
});

export const materialRequirementsApi = {
  getMaterialRequirements,
};
